import { createSlice } from "@reduxjs/toolkit";
import { globalActions } from "../../common/components/slice";
import { hotelList } from "../../common/constants/hotel";
import { SLICE } from "../../common/constants/slice";
import CURRENCY_LIST from "../../common/constants/currency";
import { BOOKING_DATE_START_DATE } from "../../common/constants/date";
import { BREAKDOWN_LIST } from "../../common/constants/breakdown";
import { TIME_COMPARISON } from "../../common/constants/time-comparison";
import { PACE_LIST } from "../../common/constants/pace-list";
import { PACE_VARIABLE_LIST } from "../../common/constants/pace-variable";
import { format } from "date-fns";

const formatDate = (date) => format(new Date(date), 'yyyy-MM-dd');
const currentDate = new Date();
/**
 * Initial states of Dashboard function are defined here
 */
export const initialState = {
  hotel: hotelList[0],
  currency: CURRENCY_LIST[0],
  pmsSync: false,
  summaryBookingDate: {
    startDate: formatDate(new Date(BOOKING_DATE_START_DATE)),
    endDate: formatDate(new Date()),
    key: "selection",
  },
  stayDate: {
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
    key: "selection",
  },
  customComparisonDate : {
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString(),
    key: "selection",
  },
  summaryOtb: false,
  isDetailed: false,
  chartBreakdown: BREAKDOWN_LIST[0].simpleValue,
  symmetricComparisonToggle: true,
  dateComparison: TIME_COMPARISON[2].value,
  summaryAlignmentToggle: false,
  summaryPaceHorizon: PACE_LIST[0].id,
  summaryPaceVariable: PACE_VARIABLE_LIST[0].label,
  summaryForecastFilter: true,
  summaryBEFilters:{"filters": {
    "PMS_toggle": {
        "target": {
            "table": "consumption_deaggrecords",
            "columns": "channel"
        },
        "conditions": {
            "operator": "NotIn",
            "values": ["PMS"]
        }
    },
    "dynamic_PMS_toggle": {
        "target": {
            "table": "consumption_deaggrecords",
            "columns": "channel"
        },
        "conditions": {
            "operator": "NotIn",
            "values": ["PMS"]
        }
    },
    "stayDateFilter_lower": {
        "target": {
            "table": "dim_sdate",
            "columns": "StayDate"
        },
        "conditions": {
            "operator": "GreaterThanOrEqual",
            "values": formatDate(currentDate)
        }
    },
    "stayDateFilter_upper": {
        "target": {
            "table": "dim_sdate",
            "columns": "StayDate"
        },
        "conditions": {
            "operator": "LessThanOrEqual",
            "values": formatDate(currentDate)
        }
    },
    "dynamic_stayDateFilter_lower": {
        "target": {
            "table": "measures",
            "columns": "dynamic_measure"
        },
        "conditions": {
            "operator": "In",
            "values": formatDate(currentDate)
        }
    },
    "dynamic_stayDateFilter_upper": {
        "target": {
            "table": "measures",
            "columns": "dynamic_measure"
        },
        "conditions": {
            "operator": "In",
            "values": formatDate(currentDate)
        }
    },
    "currencyFilter": {
        "target": {
            "table": "measures",
            "columns": "dynamic_measure"
        },
        "conditions": {
            "operator": "In",
            "values": [
                "USD"
            ]
        }
    },
    "bookingDateFilter_lower": {
        "target": {
            "table": "dim_bdate",
            "columns": "BookingDate"
        },
        "conditions": {
            "operator": "GreaterThanOrEqual",
            "values": formatDate(new Date(BOOKING_DATE_START_DATE))
        }
    },
    "bookingDateFilter_upper": {
        "target": {
            "table": "dim_bdate",
            "columns": "BookingDate"
        },
        "conditions": {
            "operator": "LessThanOrEqual",
            "values": formatDate(currentDate)
        }
    },
    "comparisonTimeFilterStayDate_lower": {
        "target": {
            "table": "dim_sdate",
            "columns": "StayDate"
        },
        "conditions": {
            "operator": "GreaterThanOrEqual",
            "values": formatDate(currentDate.setFullYear(currentDate.getFullYear() - 1))
        }
    },
    "comparisonTimeFilterStayDate_upper": {
        "target": {
            "table": "dim_sdate",
            "columns": "StayDate"
        },
        "conditions": {
            "operator": "LessThanOrEqual",
            "values": formatDate(currentDate.setFullYear(currentDate.getFullYear() - 1))
        }
    },
    "dynamic_comparisonTimeFilterStayDate_lower": {
        "target": {
            "table": "measures",
            "columns": "dynamic_measure"
        },
        "conditions": {
            "operator": "In",
            "values": formatDate(currentDate.setFullYear(currentDate.getFullYear() - 1))
        }
    },
    "dynamic_comparisonTimeFilterStayDate_upper": {
        "target": {
            "table": "measures",
            "columns": "dynamic_measure"
        },
        "conditions": {
            "operator": "In",
            "values": formatDate(currentDate.setFullYear(currentDate.getFullYear() - 1))
        }
    },
    "comparisonTimeFilterBookingDate_lower": {
        "target": {
            "table": "dim_bdate",
            "columns": "BookingDate"
        },
        "conditions": {
            "operator": "GreaterThanOrEqual",
            "values": formatDate((new Date(BOOKING_DATE_START_DATE)).setFullYear(currentDate.getFullYear() - 1))
        }
    },
    "comparisonTimeFilterBookingDate_upper": {
        "target": {
            "table": "dim_bdate",
            "columns": "BookingDate"
        },
        "conditions": {
            "operator": "LessThanOrEqual",
            "values": formatDate(currentDate.setFullYear(currentDate.getFullYear() - 1))
        }
    },
    "typeFilterSelected": {
        "target": {
            "table": "measures",
            "columns": "type"
        },
        "conditions": {
            "operator": "In",
            "values": ["selected"]
        }
    },
    "typeFilterCompared": {
        "target": {
            "table": "measures",
            "columns": "type"
        },
        "conditions": {
            "operator": "In",
            "values": ["compared"]
        }
    }
},
"compound": {
    "compound_operator":"and",
    "filters":["PMS_toggle",
    {
    "compound_operator": "or",
    "filters": [
        {"compound_operator":"and",
            "filters":[
                "typeFilterSelected",
                {"compound_operator":"and",
                    "filters":[
                        {"compound_operator":"and",
                            "filters":["stayDateFilter_lower","stayDateFilter_upper"]},
                        {"compound_operator":"and",
                            "filters":["bookingDateFilter_lower","bookingDateFilter_upper"]}
                    ]
                }
            ]
        },
        {"compound_operator":"and",
            "filters":[
                "typeFilterCompared",
                {"compound_operator":"and",
                    "filters":[
                        {"compound_operator":"and",
                            "filters":["comparisonTimeFilterStayDate_lower","comparisonTimeFilterStayDate_upper"]},
                        {"compound_operator":"and",
                            "filters":["comparisonTimeFilterBookingDate_lower","comparisonTimeFilterBookingDate_upper"]}
                    ]
                }
            ]
        }
    ]}
    ]
}
}
};
/**
 * All actions related to dashboard feature are defined here
 */
export const summarySlice = createSlice({
  name: SLICE.SUMMARY,
  initialState,
  reducers: {
    setPmsSync(state, action) {
      state.pmsSync = action?.payload;
    },
    setSummaryBookingDate(state, action) {
      state.summaryBookingDate = action?.payload;
    },
    setSummaryOtb(state, action) {
      state.summaryOtb = action?.payload;
    },
    setIsDetailed(state, action) {
      state.isDetailed = action?.payload;
    },
    setBreakdown(state, action) {
      state.chartBreakdown = action?.payload;
    },
    setSymmetricComparisonToggle(state, action) {
      state.symmetricComparisonToggle = action?.payload;
    },
    setSummaryAlignmentToggle(state, action) {
      state.summaryAlignmentToggle = action?.payload;
    },
    setDateComparison(state, action) {
      state.dateComparison = action?.payload;
    },
    setPaceHorizon(state, action) {
      state.summaryPaceHorizon = action?.payload;
    },
    setPaceVariable(state, action) {
      state.summaryPaceVariable = action?.payload;
    },
    setSummaryForecastFilter(state, action) {
      state.summaryForecastFilter = action?.payload;
    },
    setSummaryBEFilter(state, action) {
      state.summaryBEFilters = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(globalActions.setHotel, (state, action) => ({
        ...state,
        hotel: action?.payload,
      }))
      .addCase(globalActions.setCurrency, (state, action) => ({
        ...state,
        currency: action?.payload,
      }))
      .addCase(globalActions.setStayDate, (state, action) => ({
        ...state,
        stayDate: action?.payload,
      }));
  },
});
//
export const { actions: summaryActions } = summarySlice;
